import React, { useEffect, useRef, useState } from "react";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import Footer from "../../../Components/Footer/footer";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { FcCamcorderPro } from "react-icons/fc";
import { socket } from "../../../api/socket.io";

export default function UploadForm() {
  const fileInputRef = useRef(null);
  const [uploadMode, setUploadMode] = useState(""); // single | multiple | folder
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [uploaded, setUploaded] = useState("");
  const [total, setTotal] = useState("");
  const [progress, setProgress] = useState("");
  const navigate = useNavigate();
  let { id } = useParams();
  const handleModeSelect = (e) => {
    const mode = e.target.value;
    setUploadMode(mode);
    setFiles([]);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const handleSubmit = () => {
    if (!files.length) {
      alert("Please select files first");
      return;
    }

    const formData = new FormData();
    files.forEach((file) => {
      const name =
        uploadMode === "folder" ? file.webkitRelativePath : file.name;
      formData.append("files", file, name);
    });

    formData.append("parentDriveFolderId", id);

    const headers = { "Content-Type": "multipart/form-data" };

    // setLoading(true);
    setUploaded(0);
    setTotal(0);
    setProgress(0);
    performRequest("POST", "/farmmediadrive/upload-folder", formData, headers)
      .then((res) => {
        if (res.status) {
          Toast("success", "Upload successfully!");
          navigate(`/view-farm-tranig-details/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    socket.on("uploadProgress", (data) => {
      setUploaded(data.uploaded);
      setTotal(data.total);
      setProgress(data.percentage);
    });

    return () => socket.off("uploadProgress");
  }, [socket]);

  if (loading) {
    return <LoadingPage />;
  }

  if (progress || progress === 0) {
    return (
      <div
        style={{
          height: "85vh",
          display: "flex",
          margin: "auto",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <progress value={progress} max="100" />
          <p>
            Uploaded {uploaded}/{total} ({progress}%)
          </p>
          <p>Wait till uplaod all files...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    <FcCamcorderPro className="fs-2 me-1" />
                    Farm Training Details
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div>
                <div className="p-5">
                  <h1 className="text-center">UPLOAD MEDIA</h1>
                  <hr></hr>

                  <div className="mb-3 row">
                    <label className="w-25 form-label required col-3">
                      Select Upload Media
                    </label>
                    <div className="w-100 col">
                      {/* Upload mode select */}
                      <div style={{ marginBottom: 15 }}>
                        <select
                          value={uploadMode}
                          onChange={handleModeSelect}
                          className="form-select"
                        >
                          <option value="">-- Select --</option>
                          <option value="single">Single File Upload</option>
                          <option value="multiple">
                            Multiple Files Upload
                          </option>
                          <option value="folder">Folder Upload</option>
                        </select>
                      </div>

                      {/* File input */}
                      {uploadMode && (
                        <div style={{ marginBottom: 15 }}>
                          <input
                            ref={fileInputRef}
                            type="file"
                            multiple={uploadMode !== "single"}
                            webkitdirectory={
                              uploadMode === "folder" ? "true" : undefined
                            }
                            onChange={handleFileChange}
                            className="form-control"
                          />

                          <small
                            style={{
                              display: "block",
                              marginTop: 5,
                              color: "#666",
                            }}
                          >
                            {uploadMode === "single" && "Upload one file only"}
                            {uploadMode === "multiple" &&
                              "Select multiple files"}
                            {uploadMode === "folder" &&
                              "Select a complete folder"}
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                  {files.length > 0 && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Selected Files:
                      </label>
                      <div className="w-100 col">
                        {/* File preview */}

                        <div>
                          <ul>
                            {files.map((f, i) => (
                              <li key={i} className="fs-3">
                                {uploadMode === "folder"
                                  ? f.webkitRelativePath
                                  : f.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <p>
                        {files.length > 5
                          ? "The upload may take some time depending on the file size and number of files. Please wait until the upload is complete."
                          : ""}
                      </p>
                      <div></div>
                    </div>
                  )}
                </div>
              </div>
              <div className="card-footer">
                <div className="btn-list justify-content-end">
                  {/* Submit button */}
                  <button
                    onClick={handleSubmit}
                    disabled={!uploadMode}
                    className="btn mx-1 mt-2 btn-primary"
                  >
                    UPLOAD MEDIA
                  </button>
                  <SimpleButton buttonText="Cancel" type="secondary" />
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}
